import { Dropdown, Form, InputGroup, Nav, Spinner, Tab } from "react-bootstrap";
import React, { FunctionComponent, useEffect, useState } from "react";
import RostersInfoBar from "./RostersInfoBar";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect, useSelector } from "react-redux";
import {
  changeStudentsDisplaySetting,
  changeStudentsFilter,
  changeTeacherSearchFilter,
  clearStoredCsvFile,
  getCoaches,
  getDataSharingTableData,
  getSchools,
  getStudents,
  getTeachers,
  openInviteTeachersModal,
  openSchoolModal,
  openShareDataModal,
  openStudentInviteIndividuallyModal,
  openUploadStudentsRosterModal,
  resetStudentRosterUploaded,
  showLoadingIndicator,
} from "../../../../../store/onboarding/actions";
import { push } from "connected-react-router";
import TeachersTable from "../../../../../containers/onboarding/second-step/teacher-details/TeachersTable";
import TeachersInvitePanel from "../teacher-details/TeachersInvitePanel";
import UploadStudentsRosterModal from "../../../../../containers/onboarding/second-step/students/UploadStudentsRosterModal";
import StudentsInviteIndividuallyModal from "../../../../../containers/onboarding/second-step/students/StudentsInviteIndividuallyModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faCog,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  CoachInfo,
  DataSharingTableData,
  School,
  StudentInfo,
  StudentsDisplaySettings,
  TeacherInfo,
} from "../../../../../store/onboarding/types";
import AddSchoolModal from "../schools/SchoolModal";
import UploadTeachersRosterModal from "../upload-educators/UploadTeachersRosterModal";
import StudentsPane from "../students/StudentsPane";
import { RouteComponentProps, useHistory, withRouter } from "react-router";
import usePrevProps from "../../../../../utils/hooks/usePrevProps";
import InviteEducatorDropDown from "./InviteEducatorDropDown";
import MyTeachersTable from "./my-teachers-table/MyTeachersTable";
import SharingNavigationActions from "./SharingNavigationActions";
import UploadStudentDemographicsCsvButton from "./UploadStudentDemographicsCsvButton";
import useUserRole from "../../../../../utils/hooks/useUserRole";
import DistrictAccessDataSettingUpsertModal from "../../../../pages/district-owner-dashboard/tabs/data-access/DistrictAccessDataSettingUpsertModal";
import { callFromStudentDetail } from "../../../../../store/onboarding/cases/actions";
import { EventKey } from "react-bootstrap/esm/types";

export enum SecondStepTabKeys {
  TEACHERS = "teachers",
  STUDENTS = "students",
  EVIDENCE = "evidence",
}

type PropsFromState = {
  isDataManagerUser: boolean;
  teachersNotEmpty: boolean;
  studentsNotEmpty: boolean;
  schools: Array<School>;
  dataSharingTableData: Array<DataSharingTableData>;
  isLoading: {
    getTeachers: boolean;
    getCoaches: boolean;
    getStudents: boolean;
    getDataSharingTableData: boolean;
    getSchools: boolean;
  };
  errors: {
    getTeachers?: string;
    getCoaches?: string;
    getStudents?: string;
  };
  studentsFilter: string;
  teachersFilter: string;
  studentsDisplaySettings: StudentsDisplaySettings;
  isStudentRosterUploaded?: boolean;
  newStudents?: number[];
};

type DispatchProps = {
  getTeachers: () => any;
  getCoaches: () => any;
  getStudents: () => any;
  getSchools: () => any;
  getDataSharingTableData: () => any;
  openInviteTeachersModal: () => any;
  openShareDataModal: () => any;
  openSchoolModal: (selectedSchool?: School) => any;
  clearStoredCsvFile: () => any;
  openUploadStudentsRosterModal: () => any;
  openStudentInviteIndividuallyModal: () => any;
  push: (location: string) => any;
  changeStudentsDisplaySetting: (
    studentsDisplaySettings: StudentsDisplaySettings
  ) => any;
  changeStudentsFilter: (studentFilter: string) => any;
  changeTeacherSearchFilter: (teacherFilter: string) => any;
  callFromStudentDetail: (isStudentDetail: boolean) => any;
  showLoadingIndicator: () => void;
  resetStudentRosterUploaded: () => void;
};

type OwnProps = {
  activeKey: SecondStepTabKeys | null;
  id?: string;
};

type Props = OwnProps & PropsFromState & DispatchProps & RouteComponentProps;

// const CustomDivToggle = React.forwardRef((props: any, ref: any) => {
//   return (
//     <div onClick={props.onClick} ref={ref}>
//       {props.children}
//     </div>
//   );
// });

const RostersTab: FunctionComponent<Props> = (props) => {
  const { isTeacher, isCoach, isDistrictOwner} = useUserRole();
  const [isOnlyStudentChecked, setIsOnlyStudentChecked] = useState(false);
  const teachers = useSelector<ApplicationState, TeacherInfo[]>(
      (s) => s.onboarding.teachersRoster
    );
  const coaches = useSelector<ApplicationState, CoachInfo[]>(
      (s) => s.onboarding.coachesRosterWithDummyUser
    );
  const students = useSelector<ApplicationState, StudentInfo[]>(
      (s) => s.onboarding.studentsRoster
  );

  useEffect(() => {
    if(!isDistrictOwner){
      if (!(teachers.length || props.isLoading.getTeachers)) {
        props.getTeachers();
      }
      if (!(coaches.length || props.isLoading.getCoaches)) {
        props.getCoaches();
      }
    }
  }, []);

  useEffect(() => {
    if(props.activeKey == 'students') {
      updateDataTables(props.activeKey);
    }
  }, [props.isLoading.getStudents]);
  
  useEffect(() => {
    if(props.activeKey !== 'students') {
      updateDataTables(props.activeKey);
    }
  }, [props.activeKey]);
  const history = useHistory();
  const handleNavLinkClick = (location: string) => () => {
    history.push(location);
    props.changeStudentsFilter('');
  };
  
  const prevProps = usePrevProps({ prevPath: props.location.pathname });
  const prevPath = prevProps?.prevPath;
  
  useEffect(() => {
      props.changeTeacherSearchFilter('');
  },[prevPath])

  useEffect(() => {
    setIsOnlyStudentChecked(true);
    props.showLoadingIndicator();
    props.changeStudentsDisplaySetting(
      StudentsDisplaySettings.DISPLAY_ONLY_MY_STUDENTS
    );
  },[])

  useEffect(() => {
    if(props.isStudentRosterUploaded) {
      setIsOnlyStudentChecked(false);
      props.showLoadingIndicator();
      props.changeStudentsDisplaySetting(
        StudentsDisplaySettings.DISPLAY_ALL_STUDENTS
      );
      props.resetStudentRosterUploaded();
    }
  }, [props.isStudentRosterUploaded])

  useEffect(() => {
    if (props.studentsDisplaySettings === StudentsDisplaySettings.DISPLAY_ONLY_MY_STUDENTS) {
      setIsOnlyStudentChecked(true);
    } else {
      setIsOnlyStudentChecked(false);
    }
  },[props.studentsDisplaySettings])
  
  const handleActiveTabSelect = (activeTab: string | null) => {
    props.push("/rosters/" + activeTab);
  };

  const updateDataTables = (activeTab: string | null) => {
    switch (activeTab) {
      case SecondStepTabKeys.TEACHERS: {
        //props.getDataSharingTableData();
        if(!(teachers.length || props.isLoading.getTeachers)) {
          props.getTeachers();
        }
        return;
      }
      case SecondStepTabKeys.STUDENTS: {
        if(!props.id) {
            if(!isDistrictOwner && !(students.length || props.isLoading.getStudents)){
              props.getStudents();
            }
          }
        return;
      }
      default: {
        return;
      }
    }
  };

  const handleStudentsFilterChange = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    props.changeStudentsFilter(value);
  };

  const handleTeachersFilterChange = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    props.changeTeacherSearchFilter(value);
  };

  const handleGoBackFromStudentDetails = () => {
    if (prevPath) {
      props.history.push(prevPath);
    }
  };

  const getHeaderNavigation = (activeKey: SecondStepTabKeys | null) => {
    const { id } = props;
    if(!id) {
      return (
        <>
          {!isTeacher && !isDistrictOwner && (
            <>
              <Nav.Item className="rosterTab">
                <Nav.Link eventKey={SecondStepTabKeys.TEACHERS}>
                  My Teachers
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="rosterTab">
                <Nav.Link eventKey={SecondStepTabKeys.STUDENTS}>Students</Nav.Link>
              </Nav.Item>
            </>
          )}
        </>
      );
    }
  };

  // const getHeaderTitle = (activeKey: SecondStepTabKeys | null) => {
  //   const { id } = props;
  //   if (id) {
  //     switch (activeKey) {
  //       case SecondStepTabKeys.STUDENTS:
  //         return (
  //           <Nav.Item>
  //             <h3>
  //               <strong>Student Details</strong>
  //             </h3>
  //           </Nav.Item>
  //         );
  //       default:
  //         return;
  //     }
  //   }
  //   return;
  // };

  const isLoadingUploadStudentDemographicsCsv = useSelector<
    ApplicationState,
    boolean | undefined
  >((s) => s.onboarding.isLoading.uploadStudentDemographics);

  const handleAssignedStudentSwitch = (isChecked: boolean) => {
    setIsOnlyStudentChecked(isChecked);
    props.showLoadingIndicator();
    setTimeout(() => {
      if(isChecked) {
        props.changeStudentsDisplaySetting(
          StudentsDisplaySettings.DISPLAY_ONLY_MY_STUDENTS
        );
      } else {
        props.changeStudentsDisplaySetting(
          StudentsDisplaySettings.DISPLAY_ALL_STUDENTS
        )
      }
    }, 10);
  };
  const getHeaderActionButtons = (activeKey: SecondStepTabKeys | null) => {
    switch (activeKey) {
      case SecondStepTabKeys.TEACHERS: {
        return ''}
      case SecondStepTabKeys.STUDENTS:
        if (props.id) {
          return;
        } else {
          callFromStudentDetail(true);
          return ('');
        }
      default:
        return;
    }
  };

  const {
    activeKey,
    id,
    teachersNotEmpty,
  } = props;
  return (
    <>
      {/* {teachersNotEmpty && !id && <RostersInfoBar />} */}
      <div className="dataContainer mb-4">
       {id && activeKey === SecondStepTabKeys.STUDENTS && (
        <Nav>
          {(prevPath !== props.location.pathname) ?
                <div className="d-flex">
                  <Nav.Item>
                    <Nav.Link onClick={handleGoBackFromStudentDetails}>
                      <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
                      <span className="d-inline font-weight-semibold">Back</span>
                    </Nav.Link>
                  </Nav.Item>
                </div>
            :
                <div className="d-flex">
                  <Nav.Item>
                    <Nav.Link onClick={handleNavLinkClick(`${isDistrictOwner ? '/district' : ''}/rosters/students`)}  className="pl-0">
                      <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
                      <span className="d-inline font-weight-semibold">
                        Back
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                </div> }

        </Nav>
       )}
       
          <h2 className="font-weight-bold mb-2">
            {(activeKey == 'students') && id
              ? 'Student Group Details' 
              : isCoach 
                ? 'Educators & Student Data'
                : 'Student Data' 
            } </h2>
          <h4 className="">
            {(activeKey == 'students') && id
              ? `This page displays this student’s intervention groups.`
               : isCoach 
                  ? `View educator lists and permissions in My Teachers tab &
                    view all students in the district, update their details,
                    and access individual profiles in Students tab.`
                  : `View all students in the district, update their details, 
                      and access individual profiles.` }
          </h4>
        <Tab.Container
          activeKey={activeKey as EventKey}
          onSelect={handleActiveTabSelect}
          unmountOnExit
        >
          <Nav className="justify-content-between mt-3">
              <div className="co-auto d-flex align-items-center px-0">
                {getHeaderNavigation(activeKey)}
                {/* {getHeaderTitle(activeKey)} */}
                {getHeaderActionButtons(activeKey)}
                {!props.id 
                ?
                <InputGroup className={`filterSearchDesktop ${isCoach ? 'ml-3' : ''}`} >
                  <InputGroup.Prepend>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={SecondStepTabKeys.STUDENTS == activeKey ? props.studentsFilter : props.teachersFilter}
                    onChange={SecondStepTabKeys.STUDENTS == activeKey ? handleStudentsFilterChange : handleTeachersFilterChange}
                    className="filterSearchHeight"
                  />
                </InputGroup>
                : ''  
                }
              </div>
              {SecondStepTabKeys.STUDENTS == activeKey && !props.id && props.studentsNotEmpty && (
                <div className="col-auto d-flex align-items-center px-0 students-filter-switch">
                  <span className="list-order-swither-checkbox d-flex mr-2">
                    <label className="font-weight-bold">All Students</label>
                    <Form.Check
                      type="switch"
                      id="students-toggle"
                      checked={isOnlyStudentChecked}
                      onChange={() => handleAssignedStudentSwitch(!isOnlyStudentChecked)}
                      className="ml-2"
                    />
                    <label className="font-weight-bold">Intervention Group Students</label>
                  </span>
                  {isTeacher 
                    ? <UploadStudentDemographicsCsvButton />
                    : <Dropdown>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          variant="secondary"
                          className="whiteDropdown"
                        >
                          ADD STUDENTS
                          {isLoadingUploadStudentDemographicsCsv && (
                            <Spinner
                              className="ml-1"
                              animation="border"
                              size="sm"
                            />
                          )}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-dropdown-menu">
                          <Dropdown.Item
                            as="button"
                            onClick={props.openStudentInviteIndividuallyModal}
                          >
                            Add Individually
                          </Dropdown.Item>
                          <Dropdown.Item
                            as="button"
                            onClick={props.openUploadStudentsRosterModal}
                          >
                            Upload Roster
                          </Dropdown.Item>
    
                          <UploadStudentDemographicsCsvButton />
                        </Dropdown.Menu>
                      </Dropdown>
                    }
                </div>
              )}
          </Nav>
          {!id && <hr/>}
          <Tab.Content>
            <Tab.Pane eventKey={SecondStepTabKeys.TEACHERS}>
              {teachersNotEmpty || props.isLoading.getTeachers ? (
                <>
                <MyTeachersTable />
                <DistrictAccessDataSettingUpsertModal isShowDisabled={true} />
                </>
              ) : (
                isCoach
                  ? <div className="onboardingSecondStepEmptyContainer">
                      <h2>Educators will appear here once they are invited by a District Admin or added through a data upload.</h2>
                    </div>
                  : isDistrictOwner 
                    ? (<TeachersInvitePanel />)
                    : <div className="onboardingSecondStepEmptyContainer">{'No Teacher Available.'}</div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey={SecondStepTabKeys.STUDENTS}>     
              <StudentsPane id={id} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <AddSchoolModal />
      <UploadTeachersRosterModal />
      {/*<TeacherInviteIndividuallyModal />*/}
      <StudentsInviteIndividuallyModal />
      {!isDistrictOwner && (<UploadStudentsRosterModal />)}
      
    </>
  );
};

const mapStateToProps = ({
  auth,
  onboarding,
}: ApplicationState): PropsFromState => {
  return {
    isDataManagerUser: auth.userInfo
      ? auth.userInfo.profile.current_role === "coach"
      : false, //TODO "coach" using only for testing, change "coach" to "data_manager"
    teachersNotEmpty: onboarding.teachersRoster.length > 0,
    studentsNotEmpty: onboarding.studentsRoster.length > 0,
    schools: onboarding.schools,
    dataSharingTableData: onboarding.dataSharingTableData,
    isLoading: {
      getTeachers: onboarding.isLoading.getTeachers,
      getStudents: onboarding.isLoading.getStudents,
      getDataSharingTableData: onboarding.isLoading.getDataSharingTableData,
      getSchools: onboarding.isLoading.getSchoolsList,
      getCoaches: onboarding.isLoading.getCoaches!,
    },
    errors: {
      getTeachers: onboarding.errors.getTeachers,
      getStudents: onboarding.errors.getStudents,
      getCoaches: onboarding.errors.getCoaches,
    },
    studentsFilter: onboarding.studentsFilter,
    teachersFilter: onboarding.teachersFilter,
    studentsDisplaySettings: onboarding.studentsDisplaySettings,
    isStudentRosterUploaded: onboarding.isStudentRosterUploaded,
    newStudents: onboarding.newStudents,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getTeachers: getTeachers,
      getCoaches: getCoaches,
      getStudents: getStudents,
      getSchools: getSchools,
      getDataSharingTableData: getDataSharingTableData,
      openShareDataModal: openShareDataModal,
      openSchoolModal: openSchoolModal,
      openInviteTeachersModal: openInviteTeachersModal,
      clearStoredCsvFile: clearStoredCsvFile,
      openUploadStudentsRosterModal: openUploadStudentsRosterModal,
      openStudentInviteIndividuallyModal: openStudentInviteIndividuallyModal,
      changeStudentsFilter: changeStudentsFilter,
      changeTeacherSearchFilter: changeTeacherSearchFilter,
      changeStudentsDisplaySetting: changeStudentsDisplaySetting,
      callFromStudentDetail: callFromStudentDetail,
      showLoadingIndicator: showLoadingIndicator,
      push: push,
      resetStudentRosterUploaded: resetStudentRosterUploaded
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RostersTab));
